import { ClassesAPI } from '../../../../db/classes/api-types';
import { AttendanceProcessFailureType, Class } from '../../../../db/classes/types';
import { unix } from '../../../../utils/datetime';

export const addStartAttendanceDataToClass = (
  cls: Class | undefined,
  response: ClassesAPI.StartProxyAttendanceResponse
) => {
  if (!cls) return null;

  const { attendanceTime, numAvailable, numEnrolled, numPresent } = response;
  const newClass = { ...cls };

  newClass.attendanceInProgress = {
    isInProgress: true,
    isProxy: true,
    available: numAvailable,
    present: numPresent,
    enrolled: numEnrolled,
    startedAt: attendanceTime,
    nowMarkedPresent: 0,
    failures: [],
    failuresLastSyncedAt: -1,
  };

  newClass.attendance = {
    ...newClass.attendance,
    inProgress: true,
    startedAt: attendanceTime,
    markedInStudents: numPresent,
  };

  return newClass;
};

export const addGetAttendanceRespondersDataToClass = (
  cls: Class | undefined,
  response: ClassesAPI.GetAttendanceRespondersResponse
) => {
  if (!cls) return null;

  const { numUnresponsive } = response;
  const timestamp = unix();

  const newClass = { ...cls };

  if (!newClass.attendanceInProgress) return newClass;

  newClass.attendanceInProgress.failuresLastSyncedAt = timestamp;

  if (numUnresponsive > 0) {
    newClass.attendanceInProgress.failures = [
      ...newClass.attendanceInProgress.failures,
      {
        type: AttendanceProcessFailureType.UNRESPONSIVE_ATTENDEES_FAILURE,
        failedOn: timestamp,
        unresponsiveAttendees: numUnresponsive,
      },
    ];
  }

  return newClass;
};

export const addAttendanceMarkedPusherEventDataToClass = (
  cls: Class | undefined,
  response: { attendanceTime: UnixTime; attendee: MongoId; count: number }
) => {
  if (!cls) return null;
  const { attendanceTime, attendee, count } = response;
  const newClass = { ...cls };

  if (!newClass.attendanceInProgress) return newClass;
  if (newClass.attendanceInProgress.startedAt !== attendanceTime) return newClass;

  newClass.attendanceInProgress.present = Math.max(newClass.attendanceInProgress.present + 1, count);
  newClass.attendanceInProgress.nowMarkedPresent = newClass.attendanceInProgress.nowMarkedPresent + 1;
  newClass.attendanceInProgress.failures = newClass.attendanceInProgress.failures.filter((failure) => {
    if (failure.type === AttendanceProcessFailureType.UNRESPONSIVE_ATTENDEES_FAILURE) return true;
    return failure.attendee.userId !== attendee;
  });

  return newClass;
};
